module.exports = __webpack_public_path__ + "static/media/location-maps-letter-a.a32a9aa6.png";